import { useEffect, useState } from 'react'

export function useElementRect(target, { observeScroll = true } = {}) {
  const el = target && 'current' in target ? target.current : target

  const [rect, setRect] = useState(null)

  useEffect(() => {
    if (!el) return

    let raf = 0
    const update = () => {
      // read once per frame
      cancelAnimationFrame(raf)
      raf = requestAnimationFrame(() => {
        const r = el.getBoundingClientRect()
        setRect({
          top: r.top,
          left: r.left,
          width: r.width,
          height: r.height,
          right: r.right,
          bottom: r.bottom,
          x: r.x,
          y: r.y,
        })
      })
    }

    const ro = new ResizeObserver(update)
    ro.observe(el, { box: 'border-box' })

    if (observeScroll) {
      window.addEventListener('scroll', update, { passive: true })
    }
    window.addEventListener('resize', update)

    update() // initial

    return () => {
      ro.disconnect()
      window.removeEventListener('resize', update)
      if (observeScroll) window.removeEventListener('scroll', update)
      cancelAnimationFrame(raf)
    }
  }, [el, observeScroll])

  return rect
}
